import Company from "@model/Company";
import CreateViewModel from "@vm/Create/CreateViewModel";
import { inject, injectable } from "inversify";
import TYPES from "../../inversify.types";
// There is error in babel
// remove this after https://github.com/babel/babel/issues/9838
// will be fixed
void TYPES;
void inject;

@injectable()
export default class CompanyCreateVM extends CreateViewModel<Company, Repository<Company>> {
  constructor(@inject(TYPES.CompanyRepository) repository: Repository<Company>) {
    super(Company, repository);
  }
}
